import { createSvgIcon } from '@mui/material';

export const ToastSuccessIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none">
    <path
      d="M13.3318 3.27964C12.5254 2.87969 11.6329 2.61919 10.6827 2.53233C6.55779 2.15527 2.9082 5.19353 2.53115 9.31847C2.15409 13.4434 5.19235 17.093 9.31729 17.4701C13.4422 17.8471 17.0918 14.8089 17.4689 10.6839C17.5477 9.82165 17.4773 8.98017 17.2789 8.185"
      stroke="#1F9464"
      stroke-linecap="round"
      stroke-linejoin="round"
      strokeWidth={1.25}
    />
    <path
      d="M7.5 9.16602L9.79167 11.666L16.6667 4.16602"
      stroke="#1F9464"
      stroke-linecap="round"
      strokeWidth={1.25}
    />
  </svg>,
  'ToastSuccessIcon',
);
